import { render } from "./Classes.vue?vue&type=template&id=7ecc1e4b"
import script from "./Classes.vue?vue&type=script&lang=js"
export * from "./Classes.vue?vue&type=script&lang=js"

import "./Classes.vue?vue&type=style&index=0&id=7ecc1e4b&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__